<template>
  <v-expansion-panels v-model="panels" multiple>
    <v-expansion-panel v-for="plan in groupedPlans" :key="plan.planId">
      <v-subheader
        v-if="Boolean(plan.header)"
        class="text-subtitle-1 ma-2 grey lighten-4"
        >{{ plan.header.toUpperCase() }}</v-subheader
      >
      <template v-else>
        <v-expansion-panel-header class="flex-row-reverse">
          <v-card-title>
            {{ plan.planType }}: {{ plan.formattedStartDate }}
            <client-plan-form
              :plan="plan"
              :viewOnly="viewOnly || !plan.isActive"
            ></client-plan-form>
          </v-card-title>
        </v-expansion-panel-header>
        <v-expansion-panel-content eager>
          <service-plans-table
            :planId="plan.planId"
            :viewOnly="viewOnly || !plan.isActive"
          ></service-plans-table>
        </v-expansion-panel-content>
      </template>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import ClientPlanForm from "./client-plan-form";
import ServicePlansTable from "./service-plans-table";
export default {
  components: { ClientPlanForm, ServicePlansTable },
  props: ["plans", "active", "viewOnly"],
  data() {
    return {
      panels: this.active ? [...this.plans.keys()] : [],
    };
  },
  computed: {
    planTypes() {
      return this.$store.state.optionsModule.planTypes;
    },
    groupedPlans: function () {
      const groups = Object.groupBy(this.plans, (plan) => plan.ageCategory);
      return Object.keys(groups).flatMap((category) => [
        { header: category },
        ...groups[category],
      ]);
    },
  },
};
</script>
